const translations = {
    calibrated: 'Calibrated',
    inspected: 'Inspected',
    replaced: 'Replaced',
    serviced: 'Serviced'
};

export default translations;
